import { Text } from './Text'
import { Props } from './typings'

export function H1(props: Props) {
  const { children = '', as, className = '', style, size, weight, ...p } = props

  return (
    <Text size="$h1" weight="$bold" as={'h1'} style={style} className={className} {...p}>
      {children}
    </Text>
  )
}
